import ax from './ax';
import axJava from './axJava';

// 人脸
export function GetIdCardFrontUrl(data = {}) {
  return ax({
    url: '/api/OcrApi/GetIdCardFrontUrl',
    method: 'post',
    data,
  });
}
// 国徽
export function GetIdCardBackUrl(data = {}) {
  return ax({
    url: '/api/OcrApi/GetIdCardBackUrl',
    method: 'post',
    data,
  });
}
// 云码通人脸识别
export function YMTivingThing(data = {}) {
  return ax({
    url: '/api/OcrApi/YMTivingThing',
    method: 'post',
    data,
  });
}
// 提交身份证和活体照片
export function GetIdNameFaceServiceUrl(data = {}) {
  return ax({
    url: '/api/OcrApi/GetIdNameFaceServiceUrl',
    method: 'post',
    data,
  });
}
// 提交手持照片
export function FaceCompare(data = {}) {
  return ax({
    url: '/api/OcrApi/FaceCompare',
    method: 'post',
    data,
  });
}
// 人工审核
export function SubmitAuditAndUserImage(data = {}) {
  return ax({
    url: '/api/OcrApi/SubmitAuditAndUserImage',
    method: 'post',
    data,
  });
}
// 身份证过期，补录身份证
export function UploadIdCardImg(data = {}) {
  return ax({
    url: '/api/OcrApi/UploadIdCardImg',
    method: 'post',
    data,
  });
}
// 获取用户状态
export function GetUserStatus(data = {}) {
  return ax({
    url: '/api/UserInfo/GetUserStatus',
    method: 'post',
    data,
  });
}
// 获取上传图片服务路径
export function GetUpLoadImgUrl(data = {}) {
  return ax({
    url: '/api/Login/GetUpLoadImgUrl',
    method: 'post',
    data,
  });
}
// 人像识别（若未验证 第四步）
export function VerIdCardFace(data = {}) {
  return ax({
    url: '/api/Bank/VerIdCardFace',
    method: 'post',
    data,
  });
}
// 白卡大额人像失败申请人工审核
export function AuditBankElementsStatus(data = {}) {
  return ax({
    url: '/api/Bank/AuditBankElementsStatus',
    method: 'post',
    data,
  });
}
// 身份认证时提交多个人像
export function UpdateIdCardInfoFaceActive(data = {}) {
  return ax({
    url: '/api/Bank/UpdateIdCardInfoFaceActive',
    method: 'post',
    data,
  });
}
// 获取带参公众号二维码
export function GetOAQRCode(data = {}) {
  return axJava({
    url: '/api/OfficialAccount/GetOAQRCode',
    method: 'post',
    data,
  });
}
